export default "__VITE_ASSET__uSHGStl0__"